import { call, put, takeLatest } from 'redux-saga/effects';
import ApiManager from 'network/ApiManager';
import StatusCode from 'network/StatusCode';

// Actions
// Fetch
const FETCH_DEVICE_ECG_TOTAL_REQUESTED =
  'memo-web/device/FETCH_DEVICE_ECG_TOTAL_REQUESTED';
const FETCH_DEVICE_ECG_TOTAL_SUCCEED =
  'memo-web/device/FETCH_DEVICE_ECG_TOTAL_SUCCEED';
const FETCH_DEVICE_ECG_TOTAL_FAILED =
  'memo-web/device/FETCH_DEVICE_ECG_TOTAL_FAILED';

// Reducer
const initialState = {
  pending: false,
  data: null,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // Fetch
    case FETCH_DEVICE_ECG_TOTAL_REQUESTED:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case FETCH_DEVICE_ECG_TOTAL_SUCCEED:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case FETCH_DEVICE_ECG_TOTAL_FAILED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
}

// Action Creators
// Fetch
export function fetchDeviceSummaryRequested(deviceId, atTime) {
  return {
    type: FETCH_DEVICE_ECG_TOTAL_REQUESTED,
    deviceId: deviceId,
    atTime: atTime,
  };
}
export function fetchDeviceSummarySucceed(data) {
  return {
    type: FETCH_DEVICE_ECG_TOTAL_SUCCEED,
    data: data,
  };
}
export function fetchDeviceSummaryFailed(error) {
  return { type: FETCH_DEVICE_ECG_TOTAL_FAILED, error: error };
}

// Sagas
function* readDeviceEcgTotal(action) {
  try {
    const { status, data } = yield call(
      ApiManager.readDeviceEcgTotal,
      action.deviceId,
      action.atTime
    );

    yield put(fetchDeviceSummarySucceed(data));
  } catch (error) {
    yield put(fetchDeviceSummaryFailed(error));
  }
}

export function* saga() {
  yield takeLatest(FETCH_DEVICE_ECG_TOTAL_REQUESTED, readDeviceEcgTotal);
}
